import { Input } from "antd";
import React, { useState, useEffect } from "react";
import { FaTrash } from "react-icons/fa6";
import trans from "../../../../utils";

export default function FormOptionRadio({
	placeholder,
	radioOptions,
	id,
	onChange,
	addForm,
	localErrors,
	setLocalErrors,
}) {
	const [options, setOptions] = useState([
		{ value: "", label: `${trans("Option")} 1` },
	]);
	useEffect(() => {
		if (onChange) onChange({ target: { value: options } });
	}, [options]);
	useEffect(() => {
		setOptions(radioOptions);
	}, [id]);
	useEffect(() => {
		const newErrors = {};

		// build fresh errors for current options
		options.forEach((opt, i) => {
			if (!opt.label || opt.label.trim() === "") {
				newErrors[`${id}_${i}`] = trans("This field is required");
			}
		});

		// ✅ merge and also cleanup old radio errors
		setLocalErrors((prev) => {
			const updated = { ...prev, ...newErrors };

			// remove any old radio errors that are no longer in newErrors
			Object.keys(updated).forEach((key) => {
				if (key.startsWith(`${id}_`) && !(key in newErrors)) {
					delete updated[key];
				}
			});

			return updated;
		});
	}, [options, trans, setLocalErrors]);

	const handleLabelOptionChange = (index, newValue) => {
		setOptions((prev) =>
			prev.map((option, i) =>
				i === index ? { ...option, label: newValue } : option
			)
		);
	};
	const handleValueOptionChange = (index, newValue) => {
		setOptions((prev) =>
			prev.map((option, i) =>
				i === index ? { ...option, value: newValue } : option
			)
		);
	};

	const addOption = () => {
		setOptions((prev) => [
			...prev,
			{ label: `${trans("Option")} ${prev.length + 1}`, value: "" },
		]);
	};
	return (
		<div className="position-relative">
			<div className="task-radio-layout" key={id}>
				{options.map((option, index) => (
					<div key={index}>
						<div className="task-option-item mb-2 d-flex">
							<label htmlFor={`option-${index}`} className="form-label">
								{`${trans("Option")} ${index + 1}`}
							</label>
							<FaTrash
								color="red"
								className="task-option-bin"
								onClick={() => {
									const newOptions = [...options];
									newOptions.splice(index, 1);
									if (newOptions.length === 0) {
										newOptions.push(
											{ value: "option 1", label: `${trans("Option")} 1` },
											{ value: "option 2", label: `${trans("Option")} 2` }
										);
									}
									setOptions(newOptions);
								}}
							/>
						</div>
						<div className="ms-3 mb-2">
							<div className="flex-between mb-2">
								<label htmlFor={`option-${index}`} className="form-label">
									{trans("Label")}
								</label>
								<Input
									id={`option-${index}`}
									placeholder={placeholder}
									value={option.label}
									onChange={(e) => {
										handleLabelOptionChange(index, e.target.value);
										handleValueOptionChange(index, e.target.value);
									}}
								/>
								{localErrors[`${id}_${index}`] && (
									<div
										className="text-danger"
										style={{ marginTop: 4, fontSize: 12 }}
									>
										{localErrors[`${id}${index}`]}
									</div>
								)}
							</div>
							{/* <div className="flex-between">
								<label htmlFor={`option-${index}`} className="form-label">
									Value
								</label>
								<Input
									id={`option-${index}`}
									placeholder={placeholder}
									value={option.value}
									onChange={(e) =>
										handleValueOptionChange(index, e.target.value)
									}
								/>
							</div> */}
						</div>
					</div>
				))}
			</div>
			<div
				onClick={addOption}
				className="cursor-pointer text-blue-500 hover:text-blue-700 task-radio-add-btn"
			>
				{trans("Add")}
			</div>
		</div>
	);
}
